export default "__VITE_ASSET__d3336e9d__"